import { Box, Img, Text } from "@chakra-ui/react"
import React from "react"
import { FALLBACKIMAGES } from "../../common/commonConstants"
import { chakraTheme } from "../../theme/chakraTheme"

interface ProductThumbnailType6Props {
  bg?: string
  prodPhoto: string | null | undefined
  prodCode: string | null | undefined
  onClickCallBack?: (e: React.MouseEvent) => void
}
const fallBackText = "---"
const fallBackImage = FALLBACKIMAGES["150x150"]

export const ProductThumbnailType6 = ({
  bg = chakraTheme.colors.imageFallBackBackground,
  prodPhoto,
  prodCode,
  onClickCallBack
}: ProductThumbnailType6Props): JSX.Element => (
  <Box
    onClick={e => {
      if (onClickCallBack) {
        onClickCallBack(e)
      }
    }}
    p="1"
    // cursor={"pointer"}
    data-name="products-ProductThumbnail-6"
  >
    <Box textAlign="left" w={["118px", "196px", "196px", "196px"]} paddingBottom={2}>
      <Text variant="RButton2" color="primary" pt={[0, 0, 0, "6px"]} mb={"4px"} textColor={"black"}>
        {prodCode ?? fallBackText}
      </Text>
      <Box
        h={["118px", "196px", "196px", "196px"]}
        w={["118px", "196px", "196px", "196px"]}
        bg={bg}
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        borderRadius={"4px"}
      >
        {prodPhoto ? (
          <Box
            height="100%"
            width="100%"
            borderRadius={"4px"}
            boxShadow="0 0 18px rgba(0, 0, 0, 0.1)"
            border="1px solid rgba(133, 133, 133, 0.09)"
            background={`url('${prodPhoto}') no-repeat 50% 50%`}
            backgroundSize="contain"
          />
        ) : (
          <Img src={fallBackImage} alt="Product placeholder" height="100%" width="100%" objectFit="contain" />
        )}
      </Box>
    </Box>
  </Box>
)
